// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/renderer/svc_renderer.proto (package com.diagnocat.taskmaster_new, syntax proto3)
/* eslint-disable */

import { RenderDisplayImageReq } from "./svc_renderer_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";
import { DebugResp } from "../../model/dto_common_service_pb.js";

/**
 * @generated from service com.diagnocat.taskmaster_new.RendererService
 */
export const RendererService = {
  typeName: "com.diagnocat.taskmaster_new.RendererService",
  methods: {
    /**
     * Uploads a .webp display image of a report to S3
     *
     * @generated from rpc com.diagnocat.taskmaster_new.RendererService.RenderDisplayImage
     */
    renderDisplayImage: {
      name: "RenderDisplayImage",
      I: RenderDisplayImageReq,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Same as RenderDisplayImage, but returns the image data instead of S3 uploading for debugging
     *
     * @generated from rpc com.diagnocat.taskmaster_new.RendererService.RenderDisplayImage_Debug
     */
    renderDisplayImage_Debug: {
      name: "RenderDisplayImage_Debug",
      I: RenderDisplayImageReq,
      O: DebugResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

